module.exports = __webpack_public_path__ + "img/PT189.fc28b638.png";